import { Outlet } from 'react-router-dom';
import { useAnalyticsGtm } from '@unbooking/analytics-gtm';
import { useAuth } from '@unbooking/ui-auth';
import { useUserProfile } from '../../common/hooks';

const AnalyticsLayout = () => {
  const { isAuthenticated, userEmail } = useAuth();
  const userProfile = useUserProfile(isAuthenticated);

  useAnalyticsGtm({
    authState: { isAuthenticated, userEmail },
    config: {
      serviceName: 'WFP Road Safety Academy',
      loginFlowPrefixes: ['/login', '/callback'],
      agencyName: userProfile?.agency_of_reference_domain,
    },
  });

  return <Outlet />;
};

export default AnalyticsLayout;
